import React, { useState } from "react";
import ClockInOut from "./clock/ClockInOutPage";
import "./UserDashboard.css";


export default function UserDashboard() {
  const [activeTab, setActiveTab] = useState("clock");

  const renderTabContent = () => {
    switch (activeTab) {
      case "clock":
        return <ClockInOut />;
      default:
        return null;
    }
  };

  return (
    <div className="user-dashboard">
      <h1>User Dashboard</h1>
      <div className="user-tab-buttons">
        <button
          className={`user-tab-button ${activeTab === "clock" ? "active" : ""}`}
          onClick={() => setActiveTab("clock")}
        >
          Clock In/Out
        </button>
        {/* <button
          className={`user-tab-button ${activeTab === "leaves" ? "active" : ""}`}
          onClick={() => setActiveTab("leaves")}
        >
          My Leaves
        </button> */}
      </div>
      <div className="user-tab-panel">{renderTabContent()}</div>
    </div>
  );
}
